// each reducer should handle these actions:
// FETCH_UPDATES_SUCCESS
// SET_PENDING
// SET_SAVED

const COMMON = ["createdAt", "modifiedAt", "syncedAt"];

// redux store key => [backend key, redux obj fields]
export const SYNC_PUSH_DATA_CONFIG = {
  humans: ["human", ["name", ...COMMON]],
  humanContacts: ["humanContact", ["humanId", "type", "value", ...COMMON]],
  humanComments: ["humanComment", ["humanId", "text", ...COMMON]],
  circles: ["circle", ["name", "humanIds", ...COMMON]],
  events: ["event", ["humanId", "date", "label", ...COMMON]],
};

export const SYNC_STORE_KEYS = Object.keys(SYNC_PUSH_DATA_CONFIG);
